import React, { useState, useEffect } from "react";
import { Table, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { endCutoff, formatCurrency, goToTop, startCutoff, summary } from "../Utility/function";
import { normalSort } from "../Utility/sort";
import { minusDays, NumberYMD, plusDays, stringYMDHMS, stringYMDHMS3 } from "../Utility/dateTime";
import TablePagination from '@mui/material/TablePagination';
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';
import { Modal_Product, Modal_Progress } from "../modal";
import { Download } from "../components";
import { fetchBill, updateBills } from "../redux/billSlice";

function CompareCategoryScreen() {
    const dispatch = useDispatch()
  const { t } = useTranslation();
  const { shop } = useSelector((state)=> state.shop)
  const { smartCategory, cutOff, shopId } = shop;
  const { modal_Bill, billDates, selectedBill, startDate, endDate } = useSelector((state)=> state.bill)
  const [currentDisplay, setCurrentDisplay] = useState([]) // จำนวนที่แสดงในหนึ่งหน้า
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [masterCategory, setMasterCategory] = useState([]);
  const [masterProduct, setMasterProduct] = useState([]);
  const [product_Modal, setProduct_Modal] = useState(false);
  const [product, setProduct] = useState([]);
  const [progress, setProgress] = useState(0);
  const getDates = () => {
    const today = new Date()
    
    // First day of the previous month
    const firstDayOfPreviousMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    
    // Last day of the previous month
    const lastDayOfPreviousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    
    // First day of the current month
    const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  
    // Attempt to get the same date last month
    let sameDateLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
    // Check if the same date is valid for last month
    if (lastDayOfPreviousMonth.getDate()<today.getDate()) {
      // Set to last day of the previous month if invalid
      sameDateLastMonth = lastDayOfPreviousMonth
    }
  
    return {
      firstDayOfPreviousMonth,
      lastDayOfPreviousMonth,
      firstDayOfCurrentMonth,
      sameDateLastMonth,
    };
  };
  const { firstDayOfPreviousMonth, lastDayOfPreviousMonth, firstDayOfCurrentMonth, sameDateLastMonth } = getDates();

  useEffect(()=>{
    
        search(firstDayOfPreviousMonth,new Date())
  },[])

  function search(startDate, endDate){
    let rewSearch = []
    let newSearch = []
    let start = minusDays(startDate,1)

    do {
        rewSearch.push(stringYMDHMS3(start))
        start = plusDays(start,1)
    }
    while (NumberYMD(start) < NumberYMD(plusDays(endDate,2)));
    for(const item of rewSearch){
        if(!billDates.includes(item)){
            newSearch.push(item)
        }
    }
    if(newSearch.length >0){
        setProgress(0)
        dispatch(fetchBill({
        shopId,
        billDate:newSearch,
        cutOff,
        startDate,
        endDate,
        callBack:(value)=>{
            setProgress(value)
        }
        }))
    } else {
        dispatch(updateBills({startDate,endDate,cutOff}))
    }
}

useEffect(() => {
    const now = new Date();
    const cutOffDate = new Date(cutOff);
  
    const rangeMap = {
      previousMonth: {
        start: stringYMDHMS(startCutoff(new Date(firstDayOfPreviousMonth), cutOffDate)),
        end: stringYMDHMS(endCutoff(new Date(lastDayOfPreviousMonth), cutOffDate)),
      },
      thisMonth: {
        start: stringYMDHMS(startCutoff(new Date(firstDayOfCurrentMonth), cutOffDate)),
        end: stringYMDHMS(endCutoff(now, cutOffDate)),
      },
      thisLastMonth: {
        start: stringYMDHMS(startCutoff(new Date(firstDayOfPreviousMonth), cutOffDate)),
        end: stringYMDHMS(endCutoff(sameDateLastMonth, cutOffDate)),
      },
    };
  
    const categorizedBills = {
      previousMonth: [],
      thisMonth: [],
      thisLastMonth: [],
    };
  
    selectedBill.forEach((item) => {
      const time = stringYMDHMS(item.dateTime);
      if (time > rangeMap.previousMonth.start && time <= rangeMap.previousMonth.end) {
        categorizedBills.previousMonth.push(item);
      }
      if (time > rangeMap.thisMonth.start && time <= rangeMap.thisMonth.end) {
        categorizedBills.thisMonth.push(item);
      }
      if (time > rangeMap.thisLastMonth.start && time <= rangeMap.thisLastMonth.end) {
        categorizedBills.thisLastMonth.push(item);
      }
    });
  
    const previousMonthProduct = categorizedBills.previousMonth.flatMap(a => a.product);
    const thisMonthProduct = categorizedBills.thisMonth.flatMap(a => a.product);
    const thisLastMonthProduct = categorizedBills.thisLastMonth.flatMap(a => a.product);
  
    const smartCategories = smartCategory[0]?.value || [];
  
    const layerCategory = smartCategories.map(cat => {
      const filterByCategory = (arr) => arr.filter(p => p.category && p.category[0] === cat.id);
      const previousMonthSale = summary(filterByCategory(previousMonthProduct), 'totalPrice');
      const thisMonthSale = summary(filterByCategory(thisMonthProduct), 'totalPrice');
      const thisMonthQty = summary(filterByCategory(thisMonthProduct), 'qty');
      const thisLastMonthSale = summary(filterByCategory(thisLastMonthProduct), 'totalPrice');
  
      return {
        ...cat,
        previousMonthSale,
        thisMonthSale,
        thisMonthQty,
        thisLastMonthSale,
        color: thisMonthSale > thisLastMonthSale ? 'green' : thisMonthSale === thisLastMonthSale ? 'grey' : 'red',
        rate: thisLastMonthSale > 0 ? ((thisMonthSale - thisLastMonthSale) * 100) / thisLastMonthSale : 0,
      };
    });
  
    // Merge products using a Map for fast lookup
    const productMap = new Map();
  
    const accumulateProduct = (products, type) => {
      for (const { name, id, totalPrice, qty = 0, category = [] } of products) {
        if (!productMap.has(id)) {
          productMap.set(id, {
            name,
            id,
            category,
            previousSale: 0,
            currentSale: 0,
            qty: 0,
          });
        }
        const entry = productMap.get(id);
        if (type === 'previous') {
          entry.previousSale += Number(totalPrice);
        } else {
          entry.currentSale += Number(totalPrice);
          entry.qty += qty;
        }
      }
    };
  
    accumulateProduct(thisLastMonthProduct, 'previous');
    accumulateProduct(thisMonthProduct, 'current');
  
    const newProducts = Array.from(productMap.values()).map(product => ({
      ...product,
      color: product.currentSale > product.previousSale ? 'green' : product.currentSale === product.previousSale ? 'grey' : 'red',
      rate: product.previousSale > 0 ? ((product.currentSale - product.previousSale) * 100) / product.previousSale : 0,
    }));
  
    setMasterCategory(normalSort('thisMonthSale', layerCategory));
    setMasterProduct(normalSort('currentSale', newProducts));
  }, [selectedBill]);
  

  const handleChangePage = (event, newPage) => {
      setPage(newPage); // start form 0
      goToTop()
  };

  const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      goToTop()
  };


  useEffect(()=>{
    let fData = masterCategory.map((item,index)=>{return({...item,no:index+1})}).filter((item,index)=>{return(index >=(page*rowsPerPage) && index <= ((page+1)*rowsPerPage)-1)})
      setCurrentDisplay(fData)
  },[page,rowsPerPage,masterCategory])

  const exportToXlsx = () => {
    const data = masterCategory.map((item) => ({
          [t('compare.list')]: item.name,
          [t('compare.saleQty')]: item.thisMonthQty,
          [t('compare.growth')]: item.rate,
          [t('compare.currentMonthSale')]: item.thisMonthSale,
          [t('compare.lastMonthSale')]: item.thisLastMonthSale,
          [t('compare.lastMonthSales')]: item.previousMonthSale,
        }))
  
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, t('compare.compare'));
  
    const fileName = `${t('compare.compare')}${stringYMDHMS3(startDate)}-${stringYMDHMS3(endDate)}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  function openProduct(categoryId){
    let filterCategory = masterProduct.filter(a=>a.category[0]===categoryId)
    setProduct_Modal(true)
    setProduct(filterCategory)
  }

  return (
    <div  >
        <h1>เปรียบเทียบยอดขายตามหมวดหมู่</h1>
        <Modal_Progress show={modal_Bill} progress={progress} /> 
        <Modal_Product
            show={product_Modal}
            onHide={()=>{setProduct_Modal(false)}}
            product={product}
        />
        <div style={{display:'flex',justifyContent:'flex-end'}} >
            <Download exportToXlsx={exportToXlsx} />
        </div>
        <br/>
        <Table   hover responsive  variant="light" style={styles.container3}  >
            <thead  >
            <tr>
                <th style={styles.container} >{t('reportCategory.no')}</th>
                <th style={styles.container2} >{t('compare.list')}</th>
                <th style={styles.container2} >{t('compare.saleQty')}</th>
                <th style={styles.container2}>{t('compare.growth')}(%)</th>
                <th style={styles.container2}>{t('compare.currentMonthSale')}</th>
                <th style={styles.container2}>{t('compare.lastMonthSale')}</th>
                <th style={styles.container2}>{t('compare.lastMonthSales')}</th>
                <th style={styles.container2}>{t('compare.detail')}</th>
            </tr>
            </thead>
            <tbody  >
            {currentDisplay.map((item, index) => {
                const { no, name, rate, thisMonthSale, thisLastMonthSale, previousMonthSale, thisMonthQty } = item;
                return  <tr   key={index} >
                            <td style={styles.container} >{no}.</td>
                            <td >{name}</td>
                            <td style={styles.container2} >{thisMonthQty}</td>
                            <td style={{textAlign:'center',color:item.color,width:'13%'}} >{formatCurrency(rate)}</td>
                            <td style={styles.container2}>{formatCurrency(thisMonthSale)}</td>
                            <td style={styles.container2}>{formatCurrency(thisLastMonthSale)}</td>
                            <td style={styles.container2}>{formatCurrency(previousMonthSale)}</td>
                            <td style={styles.container2}>
                                <Button onClick={()=>{openProduct(item.id)}} variant="warning" style={{width:'100px'}} >{t('compare.watch')}</Button>
                            </td>
                        </tr>
            })}
            </tbody>
        </Table>
        <TablePagination
            component="div"
            count={masterCategory.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
    </div>
  );
};

const styles = {
    container : {
        textAlign:'center', width: '9%', minWidth:'50px'
    },
    container2 : {
        textAlign:'center', width:'13%', textAlign:'center',minWidth:'150px'
    },
    container3 : {
        marginLeft:'1rem'
    }
};

export default CompareCategoryScreen;
